import { useParams } from 'react-router-dom'
import EditCronForm from './EditCronForm'
import { useGetCronsQuery } from './cronsApiSlice'
import { useGetUsersQuery } from '../users/usersApiSlice'
import useAuth from '../../hooks/useAuth'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'

const EditCron = () => {
    useTitle('CRONY: Edit Cron')

    const { id } = useParams()

    const { username, isManager, isAdmin } = useAuth()

    const { cron } = useGetCronsQuery("cronsList", {
        selectFromResult: ({ data }) => ({
            cron: data?.entities[id]
        }),
    })

    const { users } = useGetUsersQuery("usersList", {
        selectFromResult: ({ data }) => ({
            users: data?.ids.map(id => data?.entities[id])
        }),
    })

    if (!cron || !users?.length) return <PulseLoader color={"#FFF"} />


    if (!isManager && !isAdmin) {
        if (cron.username !== username) {
            return <p className="errmsg">No access</p>
        }
    }

    const content = <EditCronForm cron={cron} users={users} />

    return content
}
export default EditCron